import { render, staticRenderFns } from "./MsTab.vue?vue&type=template&id=6a9fcb04&scoped=true"
import script from "./MsTab.vue?vue&type=script&lang=js"
export * from "./MsTab.vue?vue&type=script&lang=js"
import style0 from "./MsTab.vue?vue&type=style&index=0&id=6a9fcb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9fcb04",
  null
  
)

export default component.exports